// Agents externes (Ordre 25-5) — words and small rules shared by Paramètres › Agents externes and its tests.
export const DOMAIN_LABELS = {
  administration: "Administration", architecture: "Cartographie du système", analytics: "Cockpit de direction", automation: "Automatisations", billing: "Revenus", collaborators: "Collaborateurs",
  customers: "Clients", equipment: "Matériel", finance: "Finances internes", governance: "Gouvernance", knowledge: "Base de connaissance",
  marketing: "Marketing", missions: "Missions", outils: "Outils", pages: "Guide et tableau de bord", procurement: "Achats et actifs", product: "Produit",
  prospects: "Prospects", records: "Documents et contrats", search: "Recherche", skills: "Compétences", support: "Assistance", tasks: "Tâches",
  tickets: "Tickets support", training: "Formations", utilisateurs: "Comptes",
};

export const STATE_LABELS = { active: "Actif", expired: "Expiré", revoked: "Révoqué" };
export const STATE_TONES = { active: "ok", expired: "muted", revoked: "bad" };

export const domainLabel = (slug) => DOMAIN_LABELS[slug] || slug;

export function domainsText(domains) {
  if (!domains || domains.length === 0) return "Tout ce que le compte peut lire (hors cartographie du système)";
  return domains.map(domainLabel).join(", ");
}

// « dans 12 jours », « aujourd'hui », « expiré » — from the stored expiry, in whole days.
export function expiryText(token, now = new Date()) {
  if (token.state === "revoked") return "Révoqué";
  const expiry = new Date(token.expires_at);
  if (token.state === "expired" || expiry <= now) return "Expiré";
  const dayStart = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const days = Math.round((dayStart(expiry) - dayStart(now)) / 86_400_000);  // calendar days, so « tonight » is today, not tomorrow
  if (days === 0) return "Expire aujourd'hui";
  return days === 1 ? "Expire demain" : `Expire dans ${days} jours`;
}

export function createErrors({ label, days }) {
  const errors = {};
  if (label.trim().length < 2 || label.trim().length > 60) errors.label = "Entre 2 et 60 caractères";
  const n = Number(days);
  if (!Number.isInteger(n) || n < 1 || n > 90) errors.days = "Entre 1 et 90 jours";
  return errors;
}

// What a person pastes into an agent's settings (the usual `mcpServers` shape). The secret is a placeholder unless it is given.
export function connectionSnippet(origin, secret = "<votre jeton>") {
  return JSON.stringify({ mcpServers: { "jamora-crm": { type: "http", url: `${origin}/api/mcp`, headers: { Authorization: `Bearer ${secret}` } } } }, null, 2);
}

// Where an MCP client connects, and the one-line command for Claude Code. Claude.ai, ChatGPT and Codex take the address in their own screens.
export const mcpUrl = (origin) => `${origin}/api/mcp`;
export const claudeCodeCommand = (origin) => `claude mcp add --transport http jamora-crm ${mcpUrl(origin)}`;
